export default __webpack_public_path__ + "static/media/ayodeji.c34113f9.webp";